import { getDefaultTheme, getThemeById, type ThemeMetadata } from '../config/themes'

export const getThemeMetadata = (themeId?: string | null): ThemeMetadata => {
  if (themeId) {
    const themeMetadata = getThemeById(themeId)
    if (themeMetadata) {
      return themeMetadata
    }
  }

  return getDefaultTheme()
}

export const getThemeFolder = (themeId?: string | null): string => {
  return getThemeMetadata(themeId).folder
}

export const getThemeAssetUrl = (
  cdnBaseUrl: string,
  themeId: string | null | undefined,
  path: string
): string => {
  const base = cdnBaseUrl.replace(/\/$/, '')
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${base}/${getThemeFolder(themeId)}${normalizedPath}`
}
